import { StudentProfile as DebtProfile } from '../features/debt-calculator/lib/types'
import { StudentProfile as ScholarshipProfile } from '../features/scholarships/types'

export interface SharedProfile {
    // School (both tools)
    school: string
    program: string
    programLevel: 'undergraduate' | 'graduate' | 'college' | 'professional'
    annualTuition: number | null

    // Study details (debt calculator needs these)
    studyLoad: 'full_time' | 'part_time'
    studyWeeks: number
    numberOfTerms: number
    booksSupplies: number
    livingArrangement: 'with_parents' | 'on_campus' | 'off_campus_regular' | 'off_campus_toronto'
    actualMonthlyRent?: number

    // Personal (both tools)
    age: number
    ontarioResident: boolean
    status: 'single' | 'married' | 'common_law' | 'sole_support_parent'
    worked24MonthsInARow: boolean
    yearsOutOfHighSchool: number

    // Financial (both tools)
    studentIncome: number
    studentAssets: number
    parentIncome: number
    incomeMax: number | null

    // Scholarship-specific
    demographicFlags: string[]

    // Debt calc specific
    fixedContributionWaived: boolean
    hasDependants: boolean
}

export function toDebtProfile(shared: SharedProfile): DebtProfile {
    return {
        age: shared.age,
        yearsOutOfHighSchool: shared.yearsOutOfHighSchool,
        worked24MonthsInARow: shared.worked24MonthsInARow,
        ontarioResident: shared.ontarioResident,
        status: shared.status,
        exemptions: {
            fixedContributionWaived: shared.fixedContributionWaived,
        },
        study: {
            school: shared.school,
            programName: shared.program,
            programLevel: shared.programLevel,
            studyLoad: shared.studyLoad,
            studyWeeks: shared.studyWeeks,
            numberOfTerms: shared.numberOfTerms,
            tuition: shared.annualTuition ?? 0,
            booksSupplies: shared.booksSupplies,
            livingArrangement: shared.livingArrangement,
            actualMonthlyRent: shared.actualMonthlyRent,
        },
        financial: {
            studentIncome: shared.studentIncome,
            studentAssets: shared.studentAssets,
            scholarshipsAwards: 0,
            governmentIncome: 0,
        },
        parents: {
            parent1Income: shared.parentIncome,
            parent2Income: 0,
            dependentChildrenInFamily: 1,
            childrenInPostsecondary: 1,
        },
        spouse: {
            spouseIncome: 0,
            spouseGovernmentIncome: 0,
            spouseInSchool: false,
        },
        dependants: {
            hasDependants: shared.hasDependants,
            age0To11: 0,
            age12PlusNoDisability: 0,
            age12PlusWithDisability: 0,
            childCareCosts: 0,
        },
    }
}

export function toScholarshipProfile(shared: SharedProfile): ScholarshipProfile {
    return {
        programType: shared.programLevel === 'professional' ? 'graduate' : shared.programLevel as any,
        program: shared.program,
        school: shared.school,
        annualTuition: shared.annualTuition,
        incomeMax: shared.incomeMax,
        demographicFlags: shared.demographicFlags,
    }
}